export default "__VITE_ASSET__f4Fzq8t3__"